module.exports = __webpack_public_path__ + "static/media/harmony-homes.96972b0f.png";